/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

/*COMPONENT*/
import FormListRender from "../../Components/form/FormListRender";
import Modal from "../../Components/common_modal/Modal";

/*REDUX*/
import {
  createLayer,
  getListLayerTypePoint,
} from "../../App/actions/layerNewActions";
import { getProjectListAll } from "../../App/actions/projectActions";
import { post_activities } from "../../App/actions/activities";

/*PICTURE*/
import ICON_PLUS from "../../Assets/jsx/ICON_PLUS";

/*FUNCTION*/
import isEmpty from "../../App/validation/is-empty";
import sortArray from "../../App/validation/sort-array";
import { select_field_from_default_props } from "../../App/validation/generateGeoJson";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const FORM_MENU_PAGE = ({
  auth: { user, language: authLanguage },
  layer: { form_list, loadingProcess, itemLoading },
  project: { geo_project_list_all, loadMoreBtn, loadMoreBtnLoading },
  getListLayerTypePoint,
  getProjectListAll,
  createLayer,
  post_activities,
}) => {
  const [name, set_name] = useState("");
  const [description, set_description] = useState("");
  const [modal_create_form, set_modal_create_form] = useState(false);
  const [project, set_project] = useState({});
  const [skip, set_skip] = useState(0);
  const [limit, set_limit] = useState(6);

  useEffect(() => {
    const screenW = window.screen.width;
    let initialLimit = 6;
    if (screenW > 1719) {
      initialLimit = 15;
    } else if (screenW > 1429) {
      initialLimit = 12;
    } else if (screenW > 1149) {
      initialLimit = 9;
    }
    set_limit(initialLimit);

    if (form_list.length === 0) {
      const params = {
        skip: 0,
        limit: initialLimit,
      };
      getProjectListAll();
      getListLayerTypePoint(params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggle_create_form = () => {
    set_modal_create_form((prev) => !prev);
  };

  const handleChange = (e) => {
    e.preventDefault();
    const target = e.target;
    const value = target.value;
    const targetName = target.name;

    if (targetName === "name") {
      set_name(value);
    } else if (targetName === "description") {
      set_description(value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const fields = select_field_from_default_props("Point");
    const body = {
      name,
      description,
      type: "Point",
      folder: "",
      user_id: user._id,
      geo_project_id: project._id,
      properties: fields,
      isForm: true,
      architecture: "v2",
    };
    createLayer(body);
    post_activities({
      action: "create_form",
    });
  };

  const setLoadMoreForm = () => {
    const newSkip = skip + limit;
    const params = {
      skip: newSkip,
      limit,
      append: true,
      lastProject: form_list,
    };
    getListLayerTypePoint(params);
    set_skip(newSkip);
  };

  //local storage
  const language = localStorage?.language || authLanguage || "ina";

  //content
  let button_content;
  if (loadingProcess) {
    button_content = <div className="button_block">Processing...</div>;
  } else if (!name || !description || isEmpty(project)) {
    button_content = (
      <div className="button_block background_grey">
        {dict["Create"][language]}
      </div>
    );
  } else {
    button_content = (
      <button type="submit" className="button_block background_black">
        {dict["Create"][language]}
      </button>
    );
  }

  const modal_create_form_content = modal_create_form && (
    <Modal
      modalSize="medium"
      id="modal"
      isOpen={modal_create_form}
      onClose={toggle_create_form}
      title={dict["Create a new form"][language]}
    >
      <main className="box-body">
        <form onSubmit={handleSubmit}>
          <main className="two_container_equal">
            <section style={{ width: "90%" }}>
              <div style={{ marginBottom: "10px" }}>
                {dict["Form Name/Title"][language]}:
              </div>
              <input
                type="text"
                name="name"
                id="name"
                value={name}
                placeholder={dict["Form Name/Title"][language]}
                onChange={handleChange}
                className="input_square"
              />
              <div style={{ marginTop: "20px", marginBottom: "10px" }}>
                {dict["Form Description"][language]}:
              </div>
              <textarea
                name="description"
                id="description"
                value={description}
                placeholder={dict["Form description"][language]}
                onChange={handleChange}
                rows="10"
                className="input_square"
              />
            </section>
            <section>
              <div style={{ marginBottom: "10px" }}>
                {dict["Choose Project"][language]}:
              </div>
              <div
                style={{
                  padding: "10px",
                  height: "46.5vh",
                  overflowY: "auto",
                  overflowX: "hidden",
                  border: "1px solid #aeb0b1",
                  borderRadius: "10px",
                }}
              >
                {sortArray(geo_project_list_all, "name", true).map(
                  (geo_project) => {
                    const style_id =
                      geo_project._id === project._id
                        ? "list_active"
                        : "list_non_active";
                    return (
                      <div
                        onClick={() => set_project(geo_project)}
                        id={style_id}
                        key={geo_project._id}
                        className="button_list"
                      >
                        {geo_project.name}
                      </div>
                    );
                  },
                )}
              </div>
            </section>
          </main>
          <div style={{ marginTop: "50px" }}>{button_content}</div>
        </form>
      </main>
    </Modal>
  );

  let content;
  if (
    loadingProcess &&
    itemLoading === "get_layer_point" &&
    isEmpty(form_list)
  ) {
    content = (
      <>
        <br />
        <br />
        <div className="container_light">
          {dict["Loading your data"][language]}
        </div>
        <br />
        <br />
      </>
    );
  } else {
    content = (
      <main>
        <button
          onClick={toggle_create_form}
          className="button_pill background_white margin_bottom margin_right"
        >
          <span className="badge_circle background_black">
            <ICON_PLUS />
          </span>{" "}
          {dict["Create Form"][language]}
        </button>
        <br />
        <br />
        <h1 className="text_big">Form</h1>
        <FormListRender form_list={form_list} type="personal" />
      </main>
    );
  }

  return (
    <main>
      {modal_create_form_content}
      {content}
      {loadMoreBtn ? (
        <button
          className="button button_white"
          onClick={setLoadMoreForm}
          disabled={loadMoreBtnLoading}
        >
          {dict["Load More Form"][language]}
        </button>
      ) : (
        <p>{dict["All Forms Shown"][language]}</p>
      )}
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <Helmet>
        <title>FORM</title>
        <meta name="description" content="FORM" />
      </Helmet>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  project: state.project,
});

export default connect(mapStateToProps, {
  getListLayerTypePoint,
  getProjectListAll,
  createLayer,
  post_activities,
})(FORM_MENU_PAGE);
